import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getLoginMetricsSummary = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/dashboard/logins/summary`);
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching login metrics summary:',
      error.response?.data || error,
    );
    throw error;
  }
};

export const getLoginMetricsTimeSeries = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/dashboard/logins/time-series`,
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching login metrics time series:',
      error.response?.data || error,
    );
    throw error;
  }
};

export const getSuccessfulLoginUsers = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/dashboard/logins/successful-users`,
    );
    return response.data;
  } catch (error) {
    console.error(
      'Error fetching successful login users:',
      error.response?.data || error,
    );
    throw error;
  }
};
